export const Cookies = {
    favoriteAntennas: {
        name: "favoriteAntennas",
        amount: 5,
    }
}
